import { render, staticRenderFns } from "./Processing.vue?vue&type=template&id=4989aef2&scoped=true&"
import script from "./Processing.vue?vue&type=script&lang=js&"
export * from "./Processing.vue?vue&type=script&lang=js&"
import style0 from "./Processing.vue?vue&type=style&index=0&id=4989aef2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989aef2",
  null
  
)

export default component.exports